module.exports = __webpack_public_path__ + "static/media/landingService2.f558c54f.png";